/**
 * Modal d'introduction du tutoriel de création de garantie
 */

import { Play, X } from 'lucide-react';
import { useCurrentUserWording } from '@/hooks/useVendorWording';

interface TutorialIntroProps {
  onStart: () => void;
  onSkip: () => void;
}

export const TutorialIntro = ({ onStart, onSkip }: TutorialIntroProps) => {
  const wording = useCurrentUserWording();

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[10002] tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50">
      <div className="tw-bg-white tw-rounded-lg tw-shadow-2xl tw-max-w-lg tw-w-full tw-mx-4">
        {/* Header */}
        <div className="tw-bg-gradient-to-r tw-from-affinicar-primary tw-to-affinicar-secondary tw-px-6 tw-py-4 tw-rounded-t-lg tw-flex tw-items-center tw-justify-between">
          <h2 className="tw-text-xl tw-font-bold tw-text-white">
            Bienvenue dans la création {wording.deType}
          </h2>
          <button
            onClick={onSkip}
            className="tw-text-white hover:tw-text-affinicar-lighter tw-transition-colors"
            title="Fermer"
          >
            <X className="tw-w-6 tw-h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="tw-p-6">
          <p className="tw-text-gray-700 tw-mb-4">
            C'est la première fois que vous créez {wording.withIndefinite} ?
          </p>
          <p className="tw-text-gray-700 tw-mb-6">
            Nous vous proposons un tutoriel interactif qui vous guidera pas à pas à travers toutes les étapes de création.
          </p>

          <div className="tw-bg-affinicar-lighter tw-border tw-border-affinicar-light tw-rounded-lg tw-p-4 tw-mb-6">
            <p className="tw-text-sm tw-text-affinicar-dark tw-mb-0">
              💡 <strong>Astuce :</strong> Vous pourrez toujours relancer ce tutoriel plus tard en cliquant sur le bouton "Aide" en bas à droite.
            </p>
          </div>

          {/* Actions */}
          <div className="tw-flex tw-items-center tw-gap-3">
            <button
              onClick={onStart}
              className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-py-3 tw-bg-affinicar-primary tw-text-white tw-font-medium tw-rounded-lg hover:tw-bg-affinicar-secondary tw-transition-colors"
            >
              <Play className="tw-w-5 tw-h-5" />
              Démarrer le tutoriel
            </button>
            <button
              onClick={onSkip}
              className="tw-flex-1 tw-px-6 tw-py-3 tw-text-gray-600 hover:tw-text-gray-800 tw-font-medium tw-rounded-lg tw-border tw-border-gray-300 hover:tw-bg-gray-50 tw-transition-colors"
            >
              Passer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
